import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EFItineraryContent, EFPOI, EFProduct, EFSupplier } from '../../../models/experience.model';
import { PGShowcaseElement } from '../../../pg-ui-elements/pg-showcase/pg-showcase.component';
import { EnvironmentService } from '../../../services/environment.service';
import { LocalizationService } from '../../../services/localization.service';
import { MapStylesService } from '../../../services/map-styles.service';
import { TimetableData, TimetableDataPeriod, TimetableDataHour, TimetableDataList } from '../../../models/timetable.model';
import { EFDataService } from '../../../services/ef-data.service';
import { DataService } from '../../../services/data.service';
import { PGUtilities } from '../../../utilities/pg-utilities';

@Component({
    selector: 'app-ef-product',
    templateUrl: './ef-product.component.html',
    styleUrls: ['./ef-product.component.scss'],
    standalone: false
})
export class EfProductComponent implements OnInit {

    @Input() productData:EFProduct;
    @Input() supplierData:EFSupplier;
    @Input() POIData:EFPOI;
    @Input() appMode:'web'|'kiosk'|'hybrid'|'iframe'|'iframekiosk';
    @Input() oneColumn:boolean;
    @Input() hasBack:boolean;
    @Input() hasClose:boolean;
    @Input() disableBooking:boolean;
    @Input() alwaysShowItineraryMap:boolean;

    @Output() showProduct = new EventEmitter<string>()
    @Output() goBack = new EventEmitter<void>()
    @Output() doClose = new EventEmitter<void>()

    constructor(protected localizationService:LocalizationService, protected environmentService:EnvironmentService, protected mapStylesService:MapStylesService, protected ngbModal:NgbModal, protected efDataService:EFDataService, protected dataService:DataService) { }

    CheckoutURL = null;

    useContactsQR = false;

    showcaseElements:Array<PGShowcaseElement> = null;

    isLoadingParent = false;
    parentProductData:EFProduct = null;

    isLoadingChildren = false;
    childrenProductData:Array<EFProduct> = null;

    isLoadingGoods = false;
    goodsProductData:Array<EFProduct> = null;

    imageList:Array<{ type: 'image', url: string, fit?:'cover'|'contain' }> = null;
    videoList:Array<{ type: 'video', url: string, fit?:'cover'|'contain' }> = null;
    mediaList:Array<{ type: 'image'|'video', url: string, fit?:'cover'|'contain' }> = null;

    ngOnInit(): void {
        this.CheckoutURL = this.environmentService.getApplicationURL('Checkout');

        if(this.appMode == 'kiosk' || this.appMode == 'iframekiosk') {
            this.useContactsQR = true;
        }

        if(this.productData.store_showcase != null) {

            this.showcaseElements = [];
            for(let _element of (this.productData.store_showcase)) {
                
                let _title = null;
                try {
                    _title = JSON.parse(_element.showcase_title)[this.localizationService.currentLanguage]
                }
                catch(ex) {}

                let _description = null;
                try {
                    _description = JSON.parse(_element.showcase_description)[this.localizationService.currentLanguage]
                }
                catch(ex) {}

                if(_title != null) {
                    this.showcaseElements.push({
                        title: _title,
                        image: _element.showcase_image,
                        description: _description,
                    })
                }
            }
        }

        if(this.productData.hasParent()) {
            this.isLoadingParent = true;

            this.efDataService.getResourceProduct(this.productData.resource, this.productData.parent).subscribe((data) => {
                this.isLoadingParent = false;
                this.parentProductData = data;
            }, () => {
                this.isLoadingParent = false;
            })
        }

        if(this.productData.canHaveChildren()) {
            this.isLoadingChildren = true;

            // TODO: in questo null nei gruppi, serve che mi porto dietro il filtro?
            this.efDataService.listResourceProducts(this.productData.resource, this.localizationService.currentLanguage, null, this.productData.id).subscribe((data) => {
                this.isLoadingChildren = false;
                this.childrenProductData = data;
            }, () => {
                this.isLoadingChildren = false;
            })
        }

        if(this.efDataService.isSupplierProductResource(this.productData.resource)) {
            this.isLoadingGoods = true;

            this.efDataService.listSupplierGoods(this.productData.resource, this.productData.element, this.localizationService.currentLanguage).subscribe((data) => {
                this.isLoadingGoods = false;
                this.goodsProductData = data;
            }, () => {
                this.isLoadingGoods = false;
            })
        }

        this.imageList = [];
        this.videoList = [];
        this.mediaList = [];

        if(this.productData.videos != null) {
            for(let _video of this.productData.videos) {
                this.mediaList.push({ type: 'video', url: _video });
                this.videoList.push({ type: 'video', url: _video });
            }
        }

        if(this.productData.cover != null && this.productData.cover != '') {
            this.mediaList.push({ type: 'image', url: this.productData.cover })
            this.imageList.push({ type: 'image', url: this.productData.cover })
        }

        if(this.productData.flyer != null && this.productData.flyer != '') {
            this.mediaList.push({ type: 'image', url: this.productData.flyer, fit: 'contain' })
            this.imageList.push({ type: 'image', url: this.productData.flyer, fit: 'contain' })
        }

        if(this.productData.images != null) {
            for(let _image of this.productData.images) {
                this.mediaList.push({ type: 'image', url: _image });
                this.imageList.push({ type: 'image', url: _image });
            }
        }
    }

    mapParagraphImageList(list:Array<string>) {
        let _result:Array<{ type: 'image', url: string }> = []

        for(let _image of list) {
            _result.push({ type: 'image', url: _image });
        }

        return _result;
    }

    private _mapOptionsMaps: {
        [resource:string]: {
            [prop:string]: string|((val:string) => string)
        }
    } = {
        'host': {
            'category': 'type'
        },
        'eatery': {
            'category': 'type'
        },
        /* NB: lo lascio come esempio di funzionamento per usi futuri
        'municipium:poi': {
            'category': (val:string) => {
                if(val != null) {
                    let _cSplit = val.split(',');

                    let _retVal = '';
                    for(let _cCategory of _cSplit) {
                        if(_retVal != '') _retVal += ', '

                        _retVal += this.localizationService.translate('OPTIONMAPS.ExperienceSupplier.category.' + _cCategory)
                    }

                    return _retVal;
                }
            }
        }*/
    }

    getOptionMappedDisplay(val:string, resource:string, prop:string) {
        if(val != null) {
            let _uppercaseResource = resource.charAt(0).toUpperCase() + resource.substring(1);

            if(this._mapOptionsMaps[resource] != null && this._mapOptionsMaps[resource][prop] != null) {
                let _cMap = this._mapOptionsMaps[resource][prop];
                if(typeof _cMap == 'string') {
                    prop = _cMap;
                    return this.localizationService.translate('OPTIONMAPS.' + _uppercaseResource + '.' + prop + '.' + val)
                }
                else {
                    return _cMap(val)
                }
            }
            else return this.localizationService.translate('OPTIONMAPS.' + _uppercaseResource + '.' + prop + '.' + val);
        }
    }
    
    getOptionMappedArrayStringDisplay(list:any, resource:string, prop:string) {
        if(list == null || list == '' || list == '[]') return null;
        else {
            let _cList:Array<string> = null;

            if(typeof list == 'string') _cList = PGUtilities.tryParseJSON(list, true);
            else _cList = list;

            let _retVal = '';

            if(_cList != null) {
                for(let _cVal of _cList) {
                    if(_retVal != '') _retVal += ', ';

                    _retVal += this.getOptionMappedDisplay(_cVal, resource, prop)
                }
            }

            return _retVal;
        }
    }

    getTagsDisplay(list:any) {
        if(list == null || list == '' || list == '[]') return null;
        else {
            let _cList:Array<string> = null;
        
            if(typeof list == 'string') _cList = PGUtilities.tryParseJSON(list, true);
            else _cList = list;
    
            let _retVal = '';
    
            if(_cList != null) {
                for(let _cElement of _cList) {
                    if(_retVal != '') _retVal += ', ';
                    _retVal += _cElement.replace(/\s/g, '_');
                }
            }
    
            return _retVal;
        }
    }

    @ViewChild('modalAvailabilityDetails') modalAvailabilityDetails:ElementRef;

    modalAvailabilityDetailsTarget:Array<TimetableData> = null;

    private _modalAvailabilityDetailsRef:NgbModalRef = null;

    isAvailabilityValid(availability:TimetableData) {
        for(let _day of availability.periods) {
            if(_day.year == null) return true;
            else {
                let _dateEnd = new Date(_day.year, _day.end.month, _day.end.day);
                if(_dateEnd.getTime() > Date.now()) return true;
            }
        }
    }

    hasAvailabilityDisplay() {
        let _type = this.productData.getAvailabilityType()
        return _type != 'timetable-days' && _type != 'timetable-event';
    }

    hasAvailabilityDetails(availability:TimetableDataList) {
        if(this.hasAvailabilityDisplay()) {
            for(let _item of availability.list) {
                if(!_item.unavailable && _item.hours.length > 0) return true;
            }
        }
    }

    openAvailabilityDetails(availability:TimetableDataList) {
        this.modalAvailabilityDetailsTarget = availability.toData();
        this._modalAvailabilityDetailsRef = this.ngbModal.open(this.modalAvailabilityDetails)
    }

    isAvailabilityPeriodAllYear(period:TimetableDataPeriod) {
        return period.begin.month == 1 && period.begin.day == 1 && period.end.month == 12 && period.end.day == 31;
    }

    getAvailabilityPeriodDates(period:TimetableDataPeriod) {
        let _beginYear = period.year;
        let _endYear = period.year;

        if(_beginYear != null) {
            if(period.end.month < period.begin.month || (period.end.month == period.begin.month && period.end.day < period.begin.day)) {
                _endYear++;
            }
        }

        return this.localizationService.translate('pg-timetable-editor.from-day') + ' ' + 
            this.localizationService.format.date({ year: _beginYear, month: period.begin.month, day: period.begin.day }) + ' ' +
            this.localizationService.translate('pg-timetable-editor.to-day') + ' ' + 
            this.localizationService.format.date({ year: _endYear, month: period.end.month, day: period.end.day });
    }

    closeAvailabilityDetails() {
        if(this._modalAvailabilityDetailsRef != null) this._modalAvailabilityDetailsRef.close();
    }

    getDayName(index:number) {
        index = (this.localizationService.data.weekStart + index) % 7
        return this.localizationService.data.dayNames[index].substring(0, 3)
    }

    getDayStatus(hour:TimetableDataHour, index:number) {
        index = (this.localizationService.data.weekStart + index) % 7

        return hour.days[index];
    }

    getTypeColor(type:string) {
        if(this.mapStylesService.markerStyles[type] != null) {
            return this.mapStylesService.markerStyles[type].icon.fillColor;
        }
    }
    
    getTypeIcon(type:string) {
        if(this.mapStylesService.markerStyles[type] != null) {
            return this.mapStylesService.markerStyles[type].label.text;
        }
    }

    @ViewChild('modalExternalLink') modalExternalLink:ElementRef;

    modalExternalLinkTarget:string = null;

    private _modalExternalLinkRef:NgbModalRef = null;

    openExternalLink(url:string) {
        this.modalExternalLinkTarget = url;
        this._modalExternalLinkRef = this.ngbModal.open(this.modalExternalLink)
    }

    closeExternalLink() {
        if(this._modalExternalLinkRef != null) this._modalExternalLinkRef.close();
    }

    getLanguagesDisplay(languages:Array<string>) {
        if(languages != null && languages.length > 0) {
            let _retVal = '';

            for(let _language of languages) {
                if(_retVal != '') _retVal += ', '
    
                _retVal += this.localizationService.languageLabels[_language]
            }
    
            return _retVal;
        }
    }

    isCostStartingAt(range:number|Array<number>) {
        if(range != null) {
            if(typeof range != 'number') {
                if(range[0] == 0) return false;
                else return range.length > 1
            }
            else return range > 0;
        }
    }

    getCostStartingAtDisplay(range:number|Array<number>) {
        if(range != null) {
            if(typeof range != 'number') {
                if(range[0] == 0) return this.localizationService.translate('experience-finder.ef-product.cost-free')
                else return range[0].toString() + ' ' + this.productData.getCurrencySymbol()
            }
            else return range > 0;
        }
    }

    getCostRangeDisplay(range:number|Array<number>, starting?:boolean) {
        if(range != null) {
            if(typeof range == 'number') {
                let _retVal = '<span>'

                for(let i = 0; i < 5; i++) {
                    _retVal += '<b class=" me-2 ' + (i < range ? 'text-primary' : 'text-muted') + '">' + this.productData.getCurrencySymbol() + '</b>'  
                }

                _retVal += '</span>'

                return _retVal;
            }
        }
    }

    onShowProduct(product:string) {
        this.showProduct.emit(product)
    }

    getTranslatedValue(object:any, field:string) {
        if(object.translations != null) {
            if('length' in object.translations) {
                for(let _translation of object.translations) {
                    if(_translation.language == this.localizationService.currentLanguage) {
                        if(_translation[field] != null && _translation[field] != '') return _translation[field];
                        else break;
                    }
                }
            }
            else {
                for(let i in object.translations) {
                    if(i == this.localizationService.currentLanguage) {
                        let _translation = object.translations[i];
                        if(_translation[field] != null && _translation[field] != '') return _translation[field];
                        else break;
                    }
                }
            }
        }

        return object[field];
    }

    getCheckoutURL() {
        if(this.productData.booking != null) {
            return this.productData.booking;
        }
        else if(this.efDataService.isResourceProduct(this.productData) && this.environmentService.getApplicationURL('Checkout') != null) {
            // event → experience~Event → experience (checkout book-experience)
            let _bookType = (this.dataService.getCleanResourceId(
                this.efDataService.getResourceFromProductType(this.productData.type)
            ) || this.productData.type).toLowerCase();

            return this.environmentService.getApplicationURL('Checkout') + '/book-' + _bookType + '/' + this.productData.element;
        }
    }

    getPaymentMethodDisplay() {
        if(this.productData.payment != null) {
            let _retVal = '';

            for(let _payment of this.productData.payment) {
                if(_retVal != '') _retVal += ', ';
                _retVal += this.localizationService.translate('OPTIONMAPS.Experience.payment.' + _payment)
            }

            return this.localizationService.translate('experience-finder.ef-product.payment') + ' ' + _retVal;
        }
    }

    @ViewChild('modalBookingQR') modalBookingQR:ElementRef;

    modalBookingQRTarget:string = null;

    private _modalBookingQRRef:NgbModalRef = null;

    showBookingQR(url:string) {
        this.modalBookingQRTarget = url;
        this._modalBookingQRRef = this.ngbModal.open(this.modalBookingQR)
    }

    hideBookingQR() {
        if(this._modalBookingQRRef != null) this._modalBookingQRRef.close();
    }

    getServiceTypeLabel(service:string) {
        let _uppercaseResource = this.productData.resource.charAt(0).toUpperCase() + this.productData.resource.substring(1);
        return this.localizationService.translate('RESOURCES.' + _uppercaseResource + '.fields.' + service + '.label')
    }

    getServiceItemDisplay(item:string, service:string) {
        return this.getOptionMappedDisplay(item, this.productData.resource, service.replace(/^common_/, ''))
    }

    getServiceListDisplay(list:any, service:string) {
        if(list == null || list == '' || list == '[]') return null;
        else {
            let _cList:Array<string> = null;

            if(typeof list == 'string') _cList = PGUtilities.tryParseJSON(list, true);
            else _cList = list;

            let _retVal = '';
            
            if(_cList != null) {
                for(let _cVal of _cList) {
                    if(_retVal != '') _retVal += ', ';
    
                    _retVal += this.getServiceItemDisplay(_cVal, service)
                }
            }

            return _retVal;
        }
    }

    getAdditionalDescriptionLabel(description:string) { 
        let _uppercaseResource = this.productData.resource.charAt(0).toUpperCase() + this.productData.resource.substring(1);
        return this.localizationService.translate('RESOURCES.' + _uppercaseResource + '.fields.' + description + '.label')
    }

    @ViewChild('modalShowStop') modalShowStop:ElementRef;

    modalShowStopData:EFItineraryContent = null;

    private _modalShowStopDataRef:NgbModalRef = null;

    onShowStop(stop:EFItineraryContent) {
        this.modalShowStopData = stop;
        this._modalShowStopDataRef = this.ngbModal.open(this.modalShowStop, { modalDialogClass: 'EFProduct-Modal-ShowStop', size: 'lg' })
    }

    hideShowStop() {
        this._modalShowStopDataRef.close()
    }

    cleanEmbedSrc(src:string) {
        return PGUtilities.cleanEmbedSrc(src)
    }

    getAccessibilityText(type:string, value:string) {
        return this.localizationService.translate('OPTIONMAPS.*.' + type + '.' + value + '.text')
    }

    getAccessibilityTooltip(type:string, value:string) {
        return this.localizationService.translate('OPTIONMAPS.*.' + type + '.' + value + '.tooltip')
    }

    itineraryHideMap() {
        return !this.alwaysShowItineraryMap && window.innerWidth >= 992;
    }
}
